import { render, staticRenderFns } from "./MoonSpace.vue?vue&type=template&id=2b767686"
import script from "./MoonSpace.vue?vue&type=script&lang=ts"
export * from "./MoonSpace.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports